import { z } from 'zod';

const TextNode = z.object({
  type: z.literal("text"),
  text: z.string().min(1, "Text cannot be empty"),
  format: z.number(),
  style: z.string(),
  detail: z.number(),
  mode: z.string(),
  version: z.number()
});
const ZeroWidthNode = z.object({
  type: z.literal("zeroWidth"),
  text: z.string(),
  format: z.number(),
  style: z.string(),
  detail: z.number(),
  mode: z.string(),
  version: z.number()
});
const LineBreakNode = z.object({
  type: z.literal("linebreak"),
  version: z.number()
});
const ParagraphNode = z.lazy(
  () => z.object({
    type: z.literal("paragraph"),
    children: SupportedLexicalDisplayNode.array(),
    direction: z.string().nullable(),
    format: z.string(),
    indent: z.number(),
    version: z.number()
  })
);
const CustomMentionNode = z.object({
  type: z.literal("custom-beautifulMention"),
  data: z.object({
    displayName: z.string(),
    artistId: z.string().uuid().nullable(),
    avatarUrl: z.string().nullable(),
    userId: z.string().uuid(),
    webappUri: z.string(),
    key: z.string()
  }),
  trigger: z.string(),
  value: z.string().min(1, "Text cannot be empty"),
  version: z.number()
});
const SupportedLexicalDisplayNode = ParagraphNode.or(TextNode).or(LineBreakNode).or(ZeroWidthNode).or(CustomMentionNode);
const ContentLexicalStateV1 = z.object({
  root: z.object({
    type: z.literal("root"),
    children: SupportedLexicalDisplayNode.array(),
    direction: z.string().nullable(),
    format: z.string(),
    indent: z.number(),
    version: z.number()
  })
});

export { ContentLexicalStateV1 };
